import React, { Component } from 'react';

class CadessWarning extends Component {
  render() {
    return (
      <div
        className={`form-feedback ${
          this.props.displayWarning ? 'form-warning' : 'no-form-warning'
        }`}
        onClick={this.props.handleClick}
      >
        {this.props.displayWarning ? this.props.warning : '!'}
      </div>
    );
  }
}

export default CadessWarning;
